/*
 * Automatically generated by 'ng g ng-alain:plugin icon'
 * @see https://ng-alain.com/cli/plugin#icon
 */

import {
    AlipayCircleOutline,
    ApiOutline,
    AppstoreOutline,
    HomeOutline,
    ArrowDownOutline,
    BookOutline,
    CloudOutline,
    CopyrightOutline,
    CustomerServiceOutline,
    DashboardOutline,
    DatabaseOutline,
    DingdingOutline,
    DislikeOutline,
    DownloadOutline,
    ForkOutline,
    FrownOutline,
    FullscreenExitOutline,
    FullscreenOutline,
    GithubOutline,
    GlobalOutline,
    HddOutline,
    LaptopOutline,
    LikeOutline,
    LockOutline,
    LogoutOutline,
    MailOutline,
    MenuFoldOutline,
    MenuUnfoldOutline,
    MessageOutline,
    PayCircleOutline,
    PieChartOutline,
    PrinterOutline,
    RocketOutline,
    ScanOutline,
    SettingOutline,
    ShareAltOutline,
    ShoppingCartOutline,
    SoundOutline,
    StarOutline,
    TaobaoCircleOutline,
    TaobaoOutline,
    TeamOutline,
    ToolOutline,
    TrophyOutline,
    UsbOutline,
    UserOutline,
    WeiboCircleOutline,
    ReadOutline,
    AuditOutline,
    ProfileOutline,
    ProjectOutline,
    CodeOutline,
    FlagOutline,
    GoldOutline,
    SaveOutline,
    MinusCircleOutline,
    FileTextOutline,
    LeftCircleOutline,
    CaretLeftOutline,
    RightCircleOutline,
    SlackOutline,
    FileSearchOutline,
    FundOutline,
    LineChartOutline,
    TableOutline,
    HighlightOutline,
    SecurityScanOutline,
    NotificationOutline,
    MediumWorkmarkOutline,
    AccountBookOutline,
    EyeInvisibleOutline,
    SyncOutline,
    AndroidOutline,
    AppleOutline
} from '@ant-design/icons-angular/icons';

export const ICONS_AUTO = [
    AlipayCircleOutline,
    ApiOutline,
    AppstoreOutline,
    HomeOutline,
    ArrowDownOutline,
    BookOutline,
    CloudOutline,
    CopyrightOutline,
    CustomerServiceOutline,
    DashboardOutline,
    DatabaseOutline,
    DingdingOutline,
    DislikeOutline,
    DownloadOutline,
    ForkOutline,
    FrownOutline,
    FullscreenExitOutline,
    FullscreenOutline,
    GithubOutline,
    GlobalOutline,
    HddOutline,
    LaptopOutline,
    LikeOutline,
    LockOutline,
    LogoutOutline,
    MailOutline,
    MenuFoldOutline,
    MenuUnfoldOutline,
    MessageOutline,
    PayCircleOutline,
    PieChartOutline,
    PrinterOutline,
    RocketOutline,
    ScanOutline,
    SettingOutline,
    ShareAltOutline,
    ShoppingCartOutline,
    SoundOutline,
    StarOutline,
    TaobaoCircleOutline,
    TaobaoOutline,
    TeamOutline,
    ToolOutline,
    TrophyOutline,
    UsbOutline,
    UserOutline,
    WeiboCircleOutline,
    ReadOutline,
    AuditOutline,
    ProfileOutline,
    ProjectOutline,
    CodeOutline,
    FlagOutline,
    GoldOutline,
    SaveOutline,
    MinusCircleOutline,
    FileTextOutline,
    LeftCircleOutline,
    CaretLeftOutline,
    RightCircleOutline,
    SlackOutline,
    FileSearchOutline,
    FundOutline,
    LineChartOutline,
    TableOutline,
    HighlightOutline,
    SecurityScanOutline,
    NotificationOutline,
    MediumWorkmarkOutline,
    AccountBookOutline,
    EyeInvisibleOutline,
    SyncOutline,
    AndroidOutline,
    AppleOutline
];
